import FileUploader from "./components/FileUploader.vue";

const fileUploaderv2Plugin = {
  install(app) {
    app.component("file-uploader-v2", FileUploader);
  },
};

export default fileUploaderv2Plugin;
